// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gLDR","left":"styles_left__1hfXI"};